import { useEffect } from 'react';

/**
 * Handles hash links with embedded query params (e.g. #block_id?formId=123)
 * to avoid a full page reload on same-route navigation.
 *
 * It scrolls to the element, moves query params to the URL search,
 * and triggers a popstate event for app reactivity.
 */

export default function HashScrollQuerySync() {
    useEffect(() => {
        const handleHashChange = () => {
            const fullHash = window.location.hash?.substring(1); // e.g. block_abc123?formId=...

            if (!fullHash) return;

            const [elementId, query] = fullHash.split('?');

            // If no query in hash, let the browser handle it as normal
            if (!query) return;

            // Scroll to the target element
            const el = document.getElementById(elementId);
            if (el) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }

            // Cleanly update the URL: query in search, clean hash
            const url = new URL(window.location.origin + window.location.pathname);
            url.search = `?${query}`;
            url.hash = `#${elementId}`;

            history.replaceState({}, '', url);
            window.dispatchEvent(new PopStateEvent('popstate'));
        };

        window.addEventListener('hashchange', handleHashChange);
        handleHashChange();

        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, []);

    return null;
}